import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ROUTE_PATHS } from "@/lib/index";
import { LanguageProvider } from "@/lib/LanguageContext";
import { ProfileProvider } from "@/lib/ProfileContext";

import Home from "./pages/home/Index";
import BrewPage from "./pages/brew/Index";
import GiovanniPage from "./pages/giovanni/Index";
import RoiPage from "./pages/roi/Index";
import ViewpointPage from "./pages/viewpoint/Index";
import RidmixPage from "./pages/ridmix/Index";
import StudioPage from "./pages/studio/Index";
import NotFound from "./pages/not-found/Index";

const queryClient = new QueryClient();

const App = () => (
  <MotionConfig reducedMotion="user">
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <ProfileProvider>
          <TooltipProvider>
            <Sonner position="top-right" richColors />
            <HashRouter>
              <Routes>
                <Route path={ROUTE_PATHS.HOME} element={<Home />} />
                <Route path={ROUTE_PATHS.BREW} element={<BrewPage />} />
                <Route path={ROUTE_PATHS.GIOVANNI} element={<GiovanniPage />} />
                <Route path={ROUTE_PATHS.ROI} element={<RoiPage />} />
                <Route path={ROUTE_PATHS.VIEWPOINT} element={<ViewpointPage />} />
                <Route path={ROUTE_PATHS.RIDMIX} element={<RidmixPage />} />
                <Route path={ROUTE_PATHS.STUDIO} element={<StudioPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </HashRouter>
          </TooltipProvider>
        </ProfileProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </MotionConfig>
);

export default App;
